import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalPluginNotFoundError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalPluginNotFoundError';
  }
}
